import Paragraph from '@tiptap/extension-paragraph';
import { MarkdownNodeSpec } from 'tiptap-markdown';
import { defaultMarkdownSerializer } from 'prosemirror-markdown';

import { findParentNodeOfType } from 'prosemirror-utils';

export default Paragraph.extend({
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const { state } = editor;
        const { $from, $to } = state.selection;
        editor.commands.setMeta('key', 'enter');

        // Check if the current node is a paragraph and is empty
        const isEmptyParagraph =
          $from.parent.type.name === 'paragraph' && $from.parent.content.size === 0;

        // Skip custom behavior if inside any non paragraph node
        const nodeTypes = [
          state.schema.nodes.listItem,
          state.schema.nodes.tableCell,
          state.schema.nodes.tableHeader,
          state.schema.nodes.blockquote,
          state.schema.nodes.image,
        ];
        if (nodeTypes.some(nodeType => findParentNodeOfType(nodeType)(state.selection))) {
          // Let the default behavior work
          return false;
        }

        if ($from.node().type.name === 'doc') return false;

        // Check if the cursor is at the beginning of the line
        const isAtStartOfLine = $from.parentOffset === 0;

        // Check if the cursor is at the end of the line
        const isAtEndOfLine = $from.parentOffset === $from.node().content.size;

        const nextNode = $from.doc.nodeAt($to.pos + 1); // Look ahead to the next node
        const isNextParagraphEmpty =
          nextNode &&
          nextNode.type.name === 'paragraph' &&
          nextNode.content.size === 0 &&
          $from.parent.type.name === 'paragraph' &&
          isAtEndOfLine;

        // Get the previous node.
        const docIndex = $from.index($from.depth - 1);
        const json = editor.getJSON();
        const previousNode = docIndex - 1 >= 0 ? json.content?.[docIndex - 1] : null;

        const isPrevParagraphEmpty =
          previousNode?.type === 'paragraph' &&
          !previousNode?.content &&
          isAtStartOfLine &&
          $from.parent.type.name === 'paragraph';

        if (isEmptyParagraph || isNextParagraphEmpty || isPrevParagraphEmpty) {
          editor.commands.showWarning(
            'Try to avoid extra blank lines, if necessary use Shift + Enter',
          );
          return true; // Return true to prevent creating a new paragraph
        }

        // Default behavior when the paragraph is not empty and the next node is not an empty paragraph
        return false;
      },
    };
  },
  addStorage(): { markdown: MarkdownNodeSpec } {
    return {
      markdown: {
        serialize: defaultMarkdownSerializer.nodes.paragraph,
        parse: {
          // handled by markdown-it
        },
      },
    };
  },
});
